"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSuggestionApiToken = void 0;
var searchResponseToResultPage_1 = require("@/transformers/searchResponseToResultPage");
var Api_1 = require("@/api/remote/Api");
exports.getSuggestionApiToken = function (keyword, filterType, languageCode, token, searchResultType, searchResultId) {
    var requestBody = {
        keyword: keyword,
        listingTypeId: searchResponseToResultPage_1.listTypeIdRevMap[filterType],
        searchResultType: searchResultType,
        searchResultId: searchResultId,
    };
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/data/getkeywordsuggestions",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: requestBody,
    });
};
